import React from 'react'

import config from 'config'
import styles from './Dialog.css'

const getUrlFromType = (type) => {
  let url
  if (type === 7) {
    url = `${config.site.zhike}/user`
  } else if (type === 4) {
    url = '#'
  } else {
    url = `${config.site.zhike}/corrections`
  }
  return url
}

function Dialog ({ title, tip, buttons, type, closeDialog, clickOk }) {
  const renderButtons = () =>
    buttons.map((button, index) => {
      let obj = {
        className: index > 0 || buttons.length === 1 ? styles.okButton : styles.cancelButton,
        key: index
      };

      if (button.isBuyBtn) obj.className = styles.buyButton;
      if (button.href){
        obj.onClick = button.clickFc
        obj.href = button.href
        obj.target = '_blank'
      }else if (button.clickFc){
        obj.onClick = button.clickFc
      }

      return (
        <a {...obj} >
          {button.text}
        </a>
      )
    })

  return (
    <div className={styles.container}>
      <div className={styles.dialogContainer}>
        <span className={styles.closeButton} onClick={closeDialog}>
          <i className="icon-close" />
        </span>
        <div className={styles.content}>
          <div className={styles.header}>
            <h3>{title}</h3>
          </div>
          <p className={styles.tips}>{ tip }</p>
          <div className={buttons.length ? styles.contentWithButton : styles.contentNoButton}>
            <div className={styles.dialogButton}>
              { renderButtons() }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dialog



/** WEBPACK FOOTER **
 ** ./src/components/QuestionList/Dialog.js
 **/